module.exports = __webpack_public_path__ + "static/bg03-a6019e8c42cd4bf0fea54e0f2e25b382.webp";